import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  moreTo,
  moreLabel = '查看全部',
}: SectionHeadingProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow && (
          <p className="font-label text-[11px] font-semibold uppercase tracking-[0.2em] text-primary-600">
            {eyebrow}
          </p>
        )}
        <h2 className="mt-2 font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-xl text-sm leading-relaxed text-foreground-600">{description}</p>
        )}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="group inline-flex cursor-pointer items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-3.5 py-2 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-line text-[14px] transition-transform group-hover:translate-x-0.5"></i>
        </Link>
      )}
    </div>
  );
}